import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

/** Glass panel used for every content tile across the site. */
export function Card({
  children,
  className,
  interactive = false,
}: {
  children: ReactNode
  className?: string
  interactive?: boolean
}) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-2xl border border-gold/12 bg-white/[0.025] p-5 backdrop-blur-sm sm:p-6',
        interactive &&
          'transition duration-300 ease-[var(--ease-out-soft)] hover:-translate-y-1 hover:border-gold/45 hover:bg-white/[0.04] hover:shadow-[0_18px_40px_-24px_var(--color-gold)]',
        className,
      )}
    >
      {children}
    </div>
  )
}
